import Vue from 'vue'
import wordCase from './wordCase.js'

Vue.directive('wordCase', wordCase)
